import { Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useState } from "react";
import Message from "../message";

function LocalResults() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [local_results, setLocal_results] = useState({ q: "", location: "" });
  const [status_local_results, setStatus_local_results] = useState("");

  const submit_local_results = async () => {
    setStatus_local_results("");

    if (local_results["q"] === "") {
      setStatus_local_results("Enter a query!");
    } else if (local_results["location"] === "") {
      setStatus_local_results("Enter a location!");
    } else {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          q: local_results["q"],
          location: local_results["location"],
        }),
      };

      try {
        const response = await fetch(
          apiServer + "api/serpapi/local_results",
          requestOptions
        );
        const local_results_id = await response.json();
        const local_results_status = local_results_id.detail
          ? local_results_id.detail
          : local_results_id;
        setStatus_local_results(local_results_status);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TextField
        style={{ marginTop: "15px", width: "100%" }}
        value={local_results.q}
        onChange={(e) =>
          setLocal_results({ ...local_results, q: e.target.value })
        }
        id="outlined-basic"
        label="Query"
        variant="filled"
      />
      <TextField
        style={{ marginTop: "2px", width: "100%" }}
        value={local_results.location}
        onChange={(e) =>
          setLocal_results({ ...local_results, location: e.target.value })
        }
        id="outlined-basic"
        label="Location"
        variant="filled"
      />
      <br></br>
      <Button
        variant="primary"
        style={{ marginTop: "20px", width: "100%" }}
        onClick={() => submit_local_results()}
      >
        Submit
      </Button>
      {Message(status_local_results, setStatus_local_results)}
    </div>
  );
}

export default LocalResults;
